import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bill-info__line" }
const _hoisted_2 = { class: "bill-info__label" }
const _hoisted_3 = { class: "bill-info__value" }
const _hoisted_4 = { class: "bill-info__line" }
const _hoisted_5 = { class: "bill-info__label" }
const _hoisted_6 = { class: "bill-info__value" }
const _hoisted_7 = { class: "bill-info__line" }
const _hoisted_8 = { class: "bill-info__label" }
const _hoisted_9 = { class: "bill-info__value" }
const _hoisted_10 = { class: "bill-info__line" }
const _hoisted_11 = { class: "bill-info__label" }
const _hoisted_12 = {
  key: 1,
  class: "bill-info__value"
}
const _hoisted_13 = { class: "bill-info__line bill-info__line--field" }
const _hoisted_14 = { class: "bill-info__label" }
const _hoisted_15 = {
  key: 0,
  class: "bill-info__value"
}
const _hoisted_16 = { class: "bill-info__line bill-info__line--field" }
const _hoisted_17 = { class: "bill-info__label" }
const _hoisted_18 = {
  key: 0,
  class: "bill-info__value"
}
const _hoisted_19 = { class: "bill-info__bar" }
const _hoisted_20 = {
  key: 0,
  class: "bill-info__green"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 1,
  class: "bill-info__field"
}
const _hoisted_23 = {
  key: 0,
  class: "bill-info__error"
}
const _hoisted_24 = {
  key: 0,
  class: "bill-info__line"
}
const _hoisted_25 = { class: "bill-info__label" }
const _hoisted_26 = { class: "bill-info__value" }
const _hoisted_27 = {
  key: 1,
  class: "bill-info__block"
}
const _hoisted_28 = { class: "bill-info__label" }
const _hoisted_29 = {
  key: 2,
  class: "bill-info__block"
}
const _hoisted_30 = { class: "bill-info__label" }
const _hoisted_31 = {
  key: 0,
  class: "bill-info__error"
}
const _hoisted_32 = {
  key: 1,
  class: "bill-info__actions bill-info__actions--conn"
}
const _hoisted_33 = { class: "bill-info__line" }
const _hoisted_34 = { class: "bill-info__label" }
const _hoisted_35 = { class: "bill-info__value" }
const _hoisted_36 = {
  key: 3,
  class: "bill-info__line bill-info__line--field"
}
const _hoisted_37 = { class: "bill-info__label" }
const _hoisted_38 = { class: "bill-info__value" }
const _hoisted_39 = {
  key: 4,
  class: "bill-info__line bill-info__line--field"
}
const _hoisted_40 = { class: "bill-info__label" }
const _hoisted_41 = {
  key: 0,
  class: "bill-info__value"
}
const _hoisted_42 = {
  key: 5,
  class: "bill-info__line"
}
const _hoisted_43 = { class: "bill-info__label" }
const _hoisted_44 = {
  key: 6,
  class: "bill-info__actions"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 1,
  class: "bill-info__empty"
}

import {
	computed,
	defineAsyncComponent,
	reactive,
	ref
} from "vue";
import { i18n } from "@/i18n";

import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import MoveInfoDialog from "@/components/multiedit/temporary/storageshared/MoveInfoDialog.vue";
import BillConnectionProject from "./bill-connections/BillConnectionProject.vue";
import BillConnectionIncome from "./bill-connections/BillConnectionIncome.vue";
import { FileApi } from "@/ api/FileApi";
import { financesStore, commonRequestCreds } from "@/store/finances";
import { useBillConnectionsEditor } from "@/composables/useBillConnectionsEditor";
import {
	BillInfo,
	BillEditAsker,
	StorageItemMovementInFinances
} from "@/models/interfaces/finances/finance-models";
import { CommonEntity } from "@/models/interfaces/common";
import { BillType, BillConnectionWithValuesTypeDescriptor } from "@/models/etc/types";
import { formatShortDate, payStatusText, barWidth, formatMoney } from "./bill-format";
import { useModalEscape } from "@/composables/useModalEscape";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BillInfoModal',
  emits: ["changed"],
  setup(__props, { expose: __expose, emit: __emit }) {

const t = (key: string, named?: Record<string, unknown>): string => String(named ? i18n.global.t(key, named) : i18n.global.t(key));
const CounterpartyInfoModal = defineAsyncComponent(() => import("./CounterpartyInfoModal.vue"))

const emit = __emit

const info = ref<BillInfo | null>(null)
const isLoading = ref(true)
const isSaving = ref(false)
const currentId = ref(0)

const isEditing = ref(false)
const editForm = reactive({ Number: '', Sum: '', Note: '' })

const $content = ref<HTMLElement | null>(null)
const $modal = ref<InstanceType<typeof BaseModal> | null>(null)
const $file = ref<HTMLInputElement | null>(null)
const $cpInfoModal = ref<{ onOpen: (id: number) => void } | null>(null)
const $q = useQuasar()

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
	content: $content,
	close: () => $modal.value?.onClose(),
	// В режиме правки первый Escape отменяет редактирование, второй закрывает модалку.
	intercept: () => {
		if (!isEditing.value) {
			return false
		}
		cancelEdit()
		return true
	}
})

// редактор привязок
const {
	rows: connRows,
	dirty: connDirty,
	errorText: connError,
	percentErr,
	amountErr,
	debitErr,
	init: initConnections,
	onFieldInput,
	onFieldBlur,
	detach: detachConnection,
	save: saveConnectionsRaw
} = useBillConnectionsEditor(info)

const modalTitle = computed(() => {
	const num = info.value?.Number || ''
	const base = num ? t('bill_info_title_numbered', { number: num }) : t('bill_info_title')
	return info.value?.IsDraft ? t('draft_suffix', { base }) : base
})

const statusText = computed(() => {
	const m = info.value
	if (!m) return ''
	return t((m.IsDraft || m.CreatedInCrm) ? 'bill_status_draft' : 'bill_status_approved')
})

const typeText = computed(() =>
	t(info.value?.Type === BillType.Incoming ? 'bill_type_incoming' : 'bill_type_outgoing')
)

const isOutgoing = computed(() => info.value?.Type === BillType.Outgoing)

// редактирование доступно только для черновиков / созданных в CRM
const canEdit = computed(() => !!info.value && (info.value.IsDraft || info.value.CreatedInCrm))

const parsedSum = computed(() => Number(String(editForm.Sum).replace(',', '.')))
const sumInvalid = computed(() =>
	String(editForm.Sum).trim() === '' || Number.isNaN(parsedSum.value) || parsedSum.value < 0
)

const onOpen = async (billId: number) => {
	info.value = null
	currentId.value = billId
	isEditing.value = false
	isLoading.value = true
	$modal.value?.onOpen()
	activateEsc()
	try {
		const data = await financesStore().getInfoCBill(billId)

		info.value = data && data.Id ? data : null
		initConnections()
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const startEdit = () => {
	const m = info.value
	if (!m) {
		return
	}
	editForm.Number = m.Number ?? ''
	editForm.Sum = String(m.Amount ?? '')
	editForm.Note = m.Note ?? ''
	isEditing.value = true
}

const cancelEdit = () => {
	isEditing.value = false
}

const reloadInfo = async () => {
	const data = await financesStore().getInfoCBill(currentId.value)
	if (data && data.Id) {
		info.value = data
	}
	initConnections()
}

const saveEdit = async () => {
	const m = info.value
	if (!m || sumInvalid.value) {
		return
	}
	const asker: BillEditAsker = {
		...commonRequestCreds(),
		Id: currentId.value,
		Sum: parsedSum.value,
		Note: editForm.Note,
		Number: isOutgoing.value ? (m.Number ?? '') : editForm.Number,
		FileId: m.File?.Id ?? 0,
		Rate: m.Rate ?? 0,
	}
	try {
		isSaving.value = true
		const res = await financesStore().billEdit(asker)
		if (res.response_ok) {
			await reloadInfo()
			isEditing.value = false
			emit('changed')
		}
	} catch (e) {
		console.error(e)
	} finally {
		isSaving.value = false
	}
}

const saveConnections = async () => {
	try {
		isSaving.value = true
		const ok = await saveConnectionsRaw(currentId.value)
		if (ok) {
			await reloadInfo()
			emit('changed')
		}
	} catch (e) {
		console.error(e)
	} finally {
		isSaving.value = false
	}
}

const onModalClose = () => $modal.value?.onClose()

const downloadFile = (file: CommonEntity | null | undefined) => {
	if (file?.Id) FileApi.FileDownload(file.Id)
}

// Загрузка/замена файла счёта. Форма FormData повторяет Angular:
// поле 'data' = blob, а имя файла в append несёт JSON-метаданные (IFormFile).
const onFileSelected = async (e: Event) => {
	const input = e.target as HTMLInputElement
	const file = input.files?.[0]
	if (!file) {
		return
	}
	const meta = { ...commonRequestCreds(), BillId: currentId.value, Filename: file.name }
	const formData = new FormData()
	formData.append('data', file, JSON.stringify(meta))
	try {
		isSaving.value = true
		await financesStore().AddFileToBill(formData)
		await reloadInfo()
		emit('changed')
	} catch (err) {
		console.error(err)
	} finally {
		isSaving.value = false
		input.value = ''
	}
}

const openMovement = (income: StorageItemMovementInFinances | undefined) => {
	if (!income?.Id) {
		return
	}
	$q.dialog({
		component: MoveInfoDialog,
		componentProps: { existingMovementId: income.Id }
	})
}

const openCounterparty = () => {
	const id = info.value?.Counterparty?.Id
	if (id != null) {
		$cpInfoModal.value?.onOpen(Number(id))
	}
}

__expose({ onOpen, onClose: onModalClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: modalTitle.value,
    loading: isLoading.value || isSaving.value,
    width: "640px",
    height: "80vh",
    onOnClose: _unref(deactivateEsc)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "$content",
        ref: $content,
        class: "bill-info"
      }, [
        (!isLoading.value && info.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('status_label')) + ":", 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(statusText.value), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('creation_date')) + ":", 1),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(formatShortDate)(info.value.Date)), 1),
                  (_unref(formatShortDate)(info.value.Date))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(",")
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(info.value.CreatedInCrm ? 'created_in_crm' : 'created_in_one_c')), 1),
                  (info.value.Creator?.Name)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(", " + _toDisplayString(info.value.Creator.Name), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('type_label')) + ":", 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(typeText.value), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('counterparty')) + ":", 1),
                (info.value.Counterparty?.Id)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "bill-info__cp",
                      onClick: openCounterparty
                    }, _toDisplayString(info.value.Counterparty.Name || '—'), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(info.value.Counterparty?.Name || '—'), 1))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('number')) + ":", 1),
                (!isEditing.value || isOutgoing.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(info.value.Number || '—'), 1))
                  : (_openBlock(), _createBlock(AppInput, {
                      key: 1,
                      modelValue: editForm.Number,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editForm.Number) = $event)),
                      class: "bill-info__input",
                      type: "number",
                      placeholder: _ctx.$t('number')
                    }, null, 8, ["modelValue", "placeholder"]))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('amount')) + ":", 1),
                (!isEditing.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_unref(formatMoney)(info.value.CalculatedAmount)) + " ", 1),
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("span", {
                          class: "bill-info__bar-fill",
                          style: _normalizeStyle({ width: _unref(barWidth)(info.value.PayedPercent) })
                        }, null, 4)
                      ]),
                      (info.value.HasPayments)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(info.value.PayedPercent ?? 0) + "% (" + _toDisplayString(_unref(formatMoney)(info.value.PayedAmount)) + ")", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(payStatusText)(info.value.PayStatus)), 1))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createVNode(AppInput, {
                        modelValue: editForm.Sum,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editForm.Sum) = $event)),
                        class: "bill-info__input",
                        type: "number",
                        placeholder: _ctx.$t('amount'),
                        error: sumInvalid.value
                      }, null, 8, ["modelValue", "placeholder", "error"]),
                      (sumInvalid.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('bill_amount_placeholder')), 1))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              (info.value.HasPayments && !isEditing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('paid_label')) + ":", 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(formatMoney)(info.value.PayedAmount)), 1)
                  ]))
                : _createCommentVNode("", true),
              (info.value.Payments?.length && !isEditing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('payments')) + ":", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.Payments, (p, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: p.Id,
                        class: "bill-info__sub"
                      }, [
                        _createTextVNode(_toDisplayString(i + 1) + ") " + _toDisplayString(_ctx.$t(p.Type === _unref(BillType).Incoming ? 'inc_abbr' : 'out_abbr')), 1),
                        (p.Counterparty?.Name)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(", " + _toDisplayString(p.Counterparty.Name), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createTextVNode(", " + _toDisplayString(_unref(formatShortDate)(p.Date)) + ", " + _toDisplayString(_unref(formatMoney)(p.TotalAmount)) + " (" + _toDisplayString(p.PaymentPercent ?? 0) + "%) ", 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(connRows).length && !isEditing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('linked')) + ":", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(connRows), (row) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: row.Descriptor + '-' + row.Id
                      }, [
                        (row.Descriptor === _unref(BillConnectionWithValuesTypeDescriptor).Project)
                          ? (_openBlock(), _createBlock(BillConnectionProject, {
                              key: 0,
                              row: row,
                              "percent-error": _unref(percentErr),
                              "amount-error": _unref(amountErr),
                              "payed-error": _unref(debitErr),
                              onInput: (t, v) => _unref(onFieldInput)(row, t, v),
                              onBlurField: ($event: any) => (_unref(onFieldBlur)(row)),
                              onDetach: ($event: any) => (_unref(detachConnection)(row))
                            }, null, 8, ["row", "percent-error", "amount-error", "payed-error", "onInput", "onBlurField", "onDetach"]))
                          : (_openBlock(), _createBlock(BillConnectionIncome, {
                              key: 1,
                              row: row,
                              "percent-error": _unref(percentErr),
                              "amount-error": _unref(amountErr),
                              "payed-error": _unref(debitErr),
                              onInput: (t, v) => _unref(onFieldInput)(row, t, v),
                              onBlurField: ($event: any) => (_unref(onFieldBlur)(row)),
                              onDetach: ($event: any) => (_unref(detachConnection)(row)),
                              onMoveInfo: ($event: any) => (openMovement(row.income))
                            }, null, 8, ["row", "percent-error", "amount-error", "payed-error", "onInput", "onBlurField", "onDetach", "onMoveInfo"]))
                      ], 64))
                    }), 128)),
                    (_unref(connError))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(connError)), 1))
                      : _createCommentVNode("", true),
                    (_unref(connDirty))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("button", {
                            class: "bill-info__btn bill-info__btn--primary",
                            onClick: saveConnections
                          }, _toDisplayString(_ctx.$t('bill_save_links')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('one_c_instance')) + ":", 1),
                _createElementVNode("span", _hoisted_35, _toDisplayString(info.value.Instance1C || _ctx.$t('by_default')), 1)
              ]),
              (isEditing.value || info.value.Note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('comment')) + ":", 1),
                    (!isEditing.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_38, _toDisplayString(info.value.Note), 1),
                          _createVNode(AppTooltip, {
                            text: _ctx.$t('edit_label')
                          }, {
                            activator: _withCtx(() => [
                              (canEdit.value)
                                ? (_openBlock(), _createBlock(AppIcon, {
                                    key: 0,
                                    class: "bill-info__note-edit",
                                    name: "edit-pencil",
                                    width: "14px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer",
                                    onClick: startEdit
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["text"])
                        ], 64))
                      : (_openBlock(), _createBlock(AppInput, {
                          key: 1,
                          modelValue: editForm.Note,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editForm.Note) = $event)),
                          class: "bill-info__input",
                          placeholder: _ctx.$t('comment')
                        }, null, 8, ["modelValue", "placeholder"]))
                  ]))
                : _createCommentVNode("", true),
              (isEditing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('file_label')) + ":", 1),
                    (info.value.File)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(info.value.File.Name), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("input", {
                      ref_key: "$file",
                      ref: $file,
                      type: "file",
                      class: "bill-info__file-hidden",
                      onChange: onFileSelected
                    }, null, 544),
                    _createElementVNode("button", {
                      class: "bill-info__btn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($file.value?.click()))
                    }, _toDisplayString(_ctx.$t(info.value.File ? 'file_replace_file' : 'file_upload')), 1)
                  ]))
                : _createCommentVNode("", true),
              (info.value.File && !isEditing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('file_label')) + ":", 1),
                    _createElementVNode("span", {
                      class: "bill-info__file",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (downloadFile(info.value.File)))
                    }, [
                      _createVNode(AppIcon, {
                        name: "download",
                        width: "14px",
                        color: "#499259",
                        cursor: "pointer"
                      }),
                      _createTextVNode(" " + _toDisplayString(info.value.File.Name), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (canEdit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    (isEditing.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            class: "bill-info__btn bill-info__btn--primary",
                            disabled: sumInvalid.value,
                            onClick: saveEdit
                          }, _toDisplayString(_ctx.$t('save')), 9, _hoisted_45),
                          _createElementVNode("button", {
                            class: "bill-info__btn",
                            onClick: cancelEdit
                          }, _toDisplayString(_ctx.$t('cancel_short')), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "bill-info__btn",
                          onClick: startEdit
                        }, _toDisplayString(_ctx.$t('edit_label')), 1))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (!isLoading.value && !info.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.$t('bill_load_error')), 1))
            : _createCommentVNode("", true)
      ], 512),
      _createVNode(_unref(CounterpartyInfoModal), {
        ref_key: "$cpInfoModal",
        ref: $cpInfoModal
      }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "loading", "onOnClose"]))
}
}

})